import { render } from "./AvantagesSection.vue?vue&type=template&id=36924664&scoped=true"
import script from "./AvantagesSection.vue?vue&type=script&lang=js"
export * from "./AvantagesSection.vue?vue&type=script&lang=js"

import "./AvantagesSection.vue?vue&type=style&index=0&id=36924664&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36924664"]])

export default __exports__